"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locales = void 0;
var Locales;
(function (Locales) {
    Locales["ARABIC"] = "ar";
    Locales["BULGARIAN"] = "bg";
    Locales["BOSNIAN"] = "bs";
    Locales["CATALAN"] = "ca";
    Locales["CZECH"] = "cs";
    Locales["DANISH"] = "da";
    Locales["GERMAN"] = "de";
    Locales["DE_FORM"] = "de-form";
    Locales["GREEK"] = "el";
    Locales["ENGLISH"] = "en";
    Locales["SPANISH"] = "es";
    Locales["ESTONIAN"] = "et";
    Locales["FINNISH"] = "fi";
    Locales["FRENCH"] = "fr";
    Locales["HEBREW"] = "he";
    Locales["CROATIAN"] = "hr";
    Locales["HUNGARIAN"] = "hu";
    Locales["INDONESIAN"] = "id";
    Locales["ITALIAN"] = "it";
    Locales["JAPANESE"] = "ja";
    Locales["KOREAN"] = "ko";
    Locales["LITHUANIAN"] = "lt";
    Locales["LATVIAN"] = "lv";
    Locales["MONGOLIAN"] = "mn";
    Locales["NORWEGIAN"] = "nb";
    Locales["DUTCH"] = "nl";
    Locales["POLISH"] = "pl";
    Locales["PORTUGUESE_BRAZIL"] = "pt-BR";
    Locales["PORTUGUESE"] = "pt";
    Locales["ROMANIAN"] = "ro";
    Locales["RUSSIAN"] = "ru";
    Locales["SLOVENIAN"] = "sl";
    Locales["SERBIAN"] = "sr";
    Locales["SWEDISH"] = "sv";
    Locales["TURKISH"] = "tr";
    Locales["VIETNAMESE"] = "vi";
    Locales["CHINESE_S"] = "zh-CN";
    Locales["CHINESE_T"] = "zh-TW";
})(Locales = exports.Locales || (exports.Locales = {}));
//# sourceMappingURL=article.types.js.map